<div class="app-l-wrapper" [class.no-header]="isUnauthorizedRoute">
  <sra-header
    *ngIf="(isAuthenticated || isLogoutRoute) && !isUnauthorizedRoute"
  ></sra-header>
  <div class="app-l-content" *ngIf="isAuthenticated || isLogoutRoute">
    <router-outlet></router-outlet>
  </div>
  <sra-preloader></sra-preloader>
  <sra-icons-library></sra-icons-library>
</div>
